import { FieldStringOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { LengthRangeRule } from '../../../../rules/repository/length-range/LengthRange.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { TextFormatRule } from '../../../../rules/repository/text-format/TextFormat.rule.ts';
import { WhiteSpaceRule } from '../../../../rules/repository/white-space/WhiteSpace.rule.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { createCommonFormSchema } from '../common/createCommonFormSchema.ts';
import { type ITextWidget } from './ITextWidget.ts';
import { TextWidgetComponent } from './TextWidgetComponent.tsx';
import {
  TextInputConfigComponent,
  TextWidgetConfigSchema,
} from './TextWidgetConfigComponent.tsx';

/**
 * Tipo del componente di input di testo.
 */
export const TextWidgetType: IWidgetType<ITextWidget> = {
  type: WidgetType.Text,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo di testo',
  icon: <FieldStringOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.String),
  formComponent: TextWidgetComponent,
  createFormSchema: ({ widget }) =>
    createCommonFormSchema(yup.string().notRequired(), widget),
  previewComponent: TextWidgetComponent,
  configValidator: TextWidgetConfigSchema,
  configComponent: TextInputConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [
    RequiredRule,
    LengthRangeRule,
    TextFormatRule,
    WhiteSpaceRule,
    CustomWarningsRule,
  ],
};
